import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'contact/search';

export function useContactSearchQuery({
	searchQuery,
	pageSize = 10,
	enabled = true,
	impersonationContext,
}: {
	searchQuery: string;
	pageSize?: number;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled: enabled && !!searchQuery && searchQuery.length >= 2,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IContact>>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'contact/autocomplete',
					queryParams: {
						fragment: searchQuery,
						pageSize: pageSize.toString(),
					},
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, searchQuery, pageSize, impersonationContext],
		staleTime: 30000, // Cache for 30 seconds
	});
}
